<div class="top-header">
  <lib-header
    [title]="''"
    #headerRef
    [user]="userName"
    (darkModeToggle)="onDarkModeToggle()"
    [isDarkMode]="isDarkMode"
    [logoUrl]="logoUrl"
    [showToggle]="false"
    [showLogout]="false"
    (profileClick)="showMenu(headerRef)"
    (logout)="onLogout()"
    [showSearch]="showSearch"
    [showNotifications]="showNotifications"
    [showRefresh]="false"
    [showSystemDate]="showSystemDate && !esPerfil30()"
    [systemDate]="systemDate() || ''"
    [systemDateLabel]="'LAYOUT.SYSTEM_DATE' | translate"
    [searchPlaceholder]="'LAYOUT.SEARCH_PLACEHOLDER' | translate"
    (search)="onGlobalSearch($event)"
    [showProductsButton]="showProducts"
    [productsButtonLabel]="'LAYOUT.HEADER.GO_TO_PRODUCTS' | translate"
    [darkModeOnLabel]="'LAYOUT.HEADER.DARK_MODE_ON' | translate"
    [darkModeOffLabel]="'LAYOUT.HEADER.DARK_MODE_OFF' | translate"
    [refreshLabel]="'LAYOUT.HEADER.REFRESH' | translate"
    [notificationsOpenLabel]="'LAYOUT.HEADER.NOTIFICATIONS_OPEN' | translate"
    [notificationsCloseLabel]="'LAYOUT.HEADER.NOTIFICATIONS_CLOSE' | translate"
    (productsClick)="productsClick()"
  >
    <!-- En el perfil 3.0 la dependencia y la fecha van en la barra de la miga (app-contexto-sesion,
         orden de Carlos, 22-oct-2026); en el perfil por defecto la fecha sigue aqui. -->
    <!-- Acceso directo al «Centro de Tareas»: solo si el menu del producto define la opcion (HT_ARQ_013, D-27) -->
    <!-- La bandeja baja aparte cuando el navegador queda libre: trae el servicio y los modelos de
         tareas, y cargada de entrada llevaba el bundle inicial por encima de su presupuesto. -->
    <span acciones class="topbar-acciones">
      @defer (on idle) {
        <app-bandeja-tareas />
      }
    </span>
  </lib-header>
  @if (showSearchResults()) {
    <div class="global-search-overlay" role="listbox">
      @if (searchResults().length > 0) {
        <div class="gs-title">
          {{ searchResults().length }}
          {{ (searchResults().length === 1 ? 'LAYOUT.RESULT' : 'LAYOUT.RESULTS') | translate }}
        </div>
        <div class="gs-list">
          @for (r of searchResults(); track r.route) {
            <button class="gs-item" type="button" (click)="onSelectSearchResult(r)">
              <lucide-icon class="gs-item-icon" [name]="r.icon"></lucide-icon>
              <span class="gs-item-text">
                <span class="gs-item-title">{{ r.label }}</span>
                @if (r.group) {
                  <span class="gs-item-group">{{ r.group }}</span>
                }
              </span>
            </button>
          }
        </div>
      } @else {
        <div class="gs-empty">{{ 'LAYOUT.NO_OPTIONS_FOUND' | translate }}</div>
      }
    </div>
  }

  @if (languages().length > 0) {
    <div class="lang-selector">
      <button
        class="lang-btn"
        type="button"
        (click)="toggleLangMenu()"
        [title]="'LAYOUT.LANGUAGE' | translate"
      >
        <span class="lang-flag">{{ activeFlag() }}</span>
      </button>
      @if (langMenuOpen()) {
        <div
          class="lang-menu"
          role="menu"
          [style.top.px]="langMenuTop()"
          [style.right.px]="langMenuRight()"
        >
          @for (l of languages(); track l.code) {
            <button
              class="lang-item"
              type="button"
              [class.active]="l.code === activeLang()"
              (click)="selectLanguage(l.code)"
            >
              <span class="lang-flag">{{ l.flagEmoji }}</span>
              <span class="lang-name">{{ l.nativeName }}</span>
            </button>
          }
        </div>
      }
    </div>
  }

  <button
    #triggerButton
    [matMenuTriggerFor]="profileMenu"
    class="menu-trigger-hidden"
    aria-hidden="true"
    tabindex="-1"
    type="button"
  >
    Menu
  </button>

  <mat-menu
    #profileMenu="matMenu"
    [overlapTrigger]="false"
    yPosition="below"
    xPosition="before"
    [class]="esPerfil30() ? 'perfil30-menu' : ''"
  >
    @if (esPerfil30()) {
      <!-- Perfil 3.0: identidad, contexto de la sesion y acciones, con la salida aparte. -->
      <div class="perfil30-identidad" tabindex="-1" (click)="$event.stopPropagation()">
        <span class="perfil30-avatar">{{ iniciales() }}</span>
        <div class="perfil30-datos">
          <div class="perfil30-nombre">{{ userFullName() || userName }}</div>
          <div class="perfil30-login">{{ userName }}</div>
          @if (userRoles()) {
            <div class="perfil30-roles">{{ userRoles() }}</div>
          }
        </div>
      </div>
      <div class="perfil30-contexto" tabindex="-1" (click)="$event.stopPropagation()">
        @if (companiaSesion()) {
          <div class="perfil30-fila">
            <lucide-icon name="building-2" [size]="12"></lucide-icon>
            <span class="perfil30-compania">{{ companiaSesion() }}</span>
          </div>
        }
        <div class="perfil30-fila">
          <lucide-icon name="server" [size]="12"></lucide-icon>
          <span class="perfil30-rotulo">{{ 'LAYOUT.PROFILE_MENU.ENVIRONMENT' | translate }}</span>
          <span class="perfil30-ambiente" [class.perfil30-ambiente--dev]="ambiente === 'dev'">
            {{ 'ENUM.ExecutionContext.' + ambiente.toUpperCase() | translate }}
          </span>
        </div>
      </div>
      <div class="perfil30-grupo">
        @for (item of opcionesPerfil(); track item.id) {
          <button
            mat-menu-item
            class="perfil30-opcion"
            (click)="onProfileAction(item)"
            type="button"
          >
            <lucide-icon [name]="iconoOpcion(item)" [size]="14"></lucide-icon>
            <span>{{ profileItemLabel(item) | translate }}</span>
          </button>
        }
      </div>
      @if (opcionSalir(); as salir) {
        <div class="perfil30-grupo">
          <button
            mat-menu-item
            class="perfil30-opcion perfil30-opcion--salir"
            (click)="onProfileAction(salir)"
            type="button"
          >
            <lucide-icon name="log-out" [size]="14"></lucide-icon>
            <span>{{ profileItemLabel(salir) | translate }}</span>
          </button>
        </div>
      }
    } @else {
      <div class="perfil-menu-header" tabindex="-1" (click)="$event.stopPropagation()">
        @if (userFullName()) {
          <div class="perfil-menu-name">{{ userFullName() }}</div>
        }
        <div class="perfil-menu-login">{{ userName }}</div>
        @if (userRoles()) {
          <div class="perfil-menu-roles">{{ userRoles() }}</div>
        }
      </div>
      <div class="perfil-menu-sep"></div>
      @for (item of itemsProfileMenu; track item.id) {
        <button mat-menu-item (click)="onProfileAction(item)" type="button">
          {{ profileItemLabel(item) | translate }}
        </button>
      }
    }
  </mat-menu>
</div>
